export const CHECKOUT_COMPLETED = 'checkout_completed';
export const REGISTRATION_COMPLETED = 'registration_complete';

export default null;
